import { getEnvVariable } from "../../../../modules/environmentalList";
import { Plugin_GetData, Plugin_PostData } from "./pluginrequests";
import { GetData, PostData } from "../requests";

// const AUTH_REQUEST_PARAMS = {    
//     "username": "DelaSoftAdmin",
//     "password": "Delasoft@123",
//     "email": "narendra.nelluri@delasoft.com"
// }

const AUTH_REQUEST_PARAMS = {    
    "username": "",
    "password": "",
    "email": ""
}

const getUserProfile = (userid) => new Promise((resolve, reject) => {
    try {
        let url = getEnvVariable('AccessPortal') === 'I' ? getEnvVariable('MasterAdmin') + `/api/${getEnvVariable('AppModuleKey')}InternalUser/UserById/` : getEnvVariable('MasterAdmin') + `/api/ExternalUser/` + getEnvVariable('ModuleKey') + `/`;       
        if (userid) {
            GetData(url + userid).then(res => {
                if(res){
                    resolve(res);
                }else{
                    resolve(null);
                }                
            })
        }
    } catch (error) {
        reject(error);
    }
});

export const Plugin_Authenticate = (pluginkey, usr) => new Promise((resolve, reject) => {
    if(usr.userId){
        getUserProfile(usr.userId).then(userdet => {
            if(pluginkey==='EPR' && userdet){
                console.log('EPR Authenticated', userdet);
                EPR_authenticate(pluginkey, userdet).then(tokenres => {
                    resolve(tokenres);
                })
            }else{
                resolve('NOTAVALIDUSER');
            }
        })
    }else{
        resolve('NOTAVALIDUSER');
    }    
})

const GetAuthenticateParams = (pluginkey) => {

    return new Promise((resolve, reject) => {
        try{
            let url = `${getEnvVariable('PluginsAPI')}/api/ConfigDataSettings/Authenticator/${pluginkey}`;
            GetData(url).then(res => {
                if(res){                    
                    AUTH_REQUEST_PARAMS.username = res.UserName;
                    AUTH_REQUEST_PARAMS.password = res.Password;
                    resolve(AUTH_REQUEST_PARAMS);
                }else{
                    resolve(null);
                }                
            })
        }catch(ex){
            console.log(ex);
            reject(ex);
        }        
    })       
}

const EPR_authenticate = async (pluginkey, usr) => {    
    return new Promise((resolve, reject) => {
        try{
            let url = `${getEnvVariable('PluginsAPI')}/api/PluginAuth/UserAuth`;
            const data = {
                email : usr.Email,
                pluginkey : pluginkey
            }
            PostData(url, data, false, null).then(res => {
                if(res && res.accessToken){                    
                    resolve(res.accessToken);
                }else{
                    resolve(null);
                }                
            })
        }catch(ex){
            console.log(ex);
            reject(ex);
        }        
    })
}

export const IsValidEPRUser = async (email) => {
    return new Promise((resolve, reject) => {
        const url = `${getEnvVariable('EPRPartnerAPI')}/persons?email=${email}`; 
        let eprAccessToken = localStorage.getItem('xaccesstoken'); 
        if(eprAccessToken){
            Plugin_GetData(url).then(res => {
                if(res && res['success'] && Array.isArray(res.data) && res.data.length > 0){
                    //localStorage.setItem('xaccesstoken', res.data.token);
                    resolve({status: true, groups: res.data[0].groups.map(g => g.label).toString(','), key:'SUCCESS'});
                } else {
                    resolve({status: false, groups: '', key:'NOTFOUND'});   
                }             
            }, err => {
                resolve({status: false, groups: ''});
            })
        }else{
            resolve({status: false, groups: '', key:'NOTAUTHORIZED'});
        }      
        
    })
}

